export default {
	HelloWorld: 'Hallo Wereld nl',
}
